module.exports = __webpack_public_path__ + "static/media/class_list_bg.fd8b5e91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/class_list_bg.jpg
// module id = 301
// module chunks = 10